const e=()=>{Object.defineProperty(window,"dataLayer",{value:[],writable:!0})};export{e as includeDataLayerStub};
